<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm"
    >
      <div class="modal-content">
        <div class="modal-dialog-scrollable-general">
          <div class="modal-header">
            <div class="header-title">
              <h4 class="m-0 title-modal">Canal bancário para recebimento</h4>
            </div>
            <div (click)="closeModal()" class="close-icon tappable">
              <img src="assets/image/close-modal-icon.svg" />
            </div>
          </div>

          <div class="modal-body">
            <div class="">
              <div class="p-3 pv-5">
                <div class="row">
                  <div class="bank-account">
                    <div class="section-bank">
                      <div class="row p-2">
                        <span>
                          <span class="label">Intermediary Bank: </span>
                          <span class="value">{{
                            currencyDetails?.intermediaryBankChannels[0]?.bank
                          }}</span>
                        </span>
                      </div>
                      <div class="row p-2">
                        <span>
                          <span class="label">Swift Code: </span>
                          <span class="value">{{
                            currencyDetails?.intermediaryBankChannels[0]?.swift
                          }}</span>
                        </span>
                      </div>
                      <div class="row p-2">
                        <span>
                          <span class="label">Account: </span>
                          <span class="value">{{
                            currencyDetails?.intermediaryBankChannels[0]
                              ?.account
                          }}</span>
                        </span>
                      </div>
                      <div class="row p-2">
                        <span>
                          <span class="label">Address: </span>
                          <span class="value">{{
                            currencyDetails?.intermediaryBankChannels[0]
                              ?.address
                          }}</span>
                        </span>
                      </div>
                    </div>

                    <div class="section-bank">
                      <div class="row p-2">
                        <span>
                          <span class="label">Beneficiary Bank: </span>
                          <span class="value">{{
                            currencyDetails?.beneficiaryBankChannels[0]?.bank
                          }}</span>
                        </span>
                      </div>
                      <div class="row p-2">
                        <span>
                          <span class="label">Swift Code: </span>
                          <span class="value">{{
                            currencyDetails?.beneficiaryBankChannels[0]?.swift
                          }}</span>
                        </span>
                      </div>
                      <div class="row p-2">
                        <span>
                          <span class="label">Address: </span>
                          <span class="value">{{
                            currencyDetails?.beneficiaryBankChannels[0]?.address
                          }}</span>
                        </span>
                      </div>
                    </div>

                    <div>
                      <div class="row p-2">
                        <p class="name pt-1">Beneficiary</p>
                      </div>
                      <div class="row p-2">
                        <span>
                          <span class="label">Account: </span>
                          <span class="value"
                            >{{ currencyDetails?.beneficiaries[0]?.account }}
                            {{
                              currencyDetails?.beneficiaries[0]?.nomecliente
                            }}</span
                          >
                        </span>
                      </div>
                      <div class="row p-2">
                        <span>
                          <span class="label">Reference: </span>
                          <span class="value">{{
                            currencyDetails?.beneficiaries[0]?.reference
                          }}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ng-container>
          <div class="buttons">
            <button
              class="btn mb-3"
              [ngClass]="
                companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
              "
              (click)="copyText()"
              type="button"
            >
              Copiar canal bancário
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
